__turbopack_context__.v({
  "centerContent": "styles-module__ZgvVSa__centerContent",
  "container": "styles-module__ZgvVSa__container",
  "gameArea": "styles-module__ZgvVSa__gameArea",
  "highScore": "styles-module__ZgvVSa__highScore",
  "landscapeLayout": "styles-module__ZgvVSa__landscapeLayout",
  "leftControls": "styles-module__ZgvVSa__leftControls",
  "portraitControls": "styles-module__ZgvVSa__portraitControls",
  "rightControls": "styles-module__ZgvVSa__rightControls",
  "score": "styles-module__ZgvVSa__score",
  "scoreBox": "styles-module__ZgvVSa__scoreBox",
  "scoreContainer": "styles-module__ZgvVSa__scoreContainer",
});
